import patterns from '@/shared/ui/styles/patterns.module.css';
import { EmptyState, Button } from '@/shared/ui';
import type { LocationPayerRow } from '../api/payersApi';
import styles from './PayersTable.module.css';

function phoneMapPills(payer: LocationPayerRow) {
  if (payer.phoneMapStatus === 'pending') {
    return <span className={patterns.pillMuted}>PENDING REVIEW</span>;
  }
  if (payer.phoneMapStatus === 'not_charted') {
    return <span className={patterns.pillMuted}>NOT CHARTED</span>;
  }
  return (
    <div className={styles.pillGroup}>
      {payer.activeVersion != null && (
        <span className={patterns.pillSuccess}>VERIFIED v{payer.activeVersion}</span>
      )}
      {payer.proposedVersion != null && (
        <span className={patterns.pillWarning}>v{payer.proposedVersion} PROPOSED</span>
      )}
    </div>
  );
}

function strategyPill(strategy: LocationPayerRow['effectiveStrategy']) {
  if (strategy === 'voice') return <span className={patterns.pillInfo}>VOICE</span>;
  if (strategy === 'blocked') return <span className={patterns.pillMuted}>BLOCKED</span>;
  return <span className={patterns.pillWarning}>STAFF (until charted)</span>;
}

interface PayersTableProps {
  payers: LocationPayerRow[];
  isLoading: boolean;
  onRemove: (payer: LocationPayerRow) => void;
}

export function PayersTable({ payers, isLoading, onRemove }: PayersTableProps) {
  if (!isLoading && payers.length === 0) {
    return (
      <EmptyState
        title="No payers added yet"
        description="Add the insurance companies this location works with — search the directory or add one manually."
      />
    );
  }

  return (
    <div className={patterns.gridTable}>
      <div className={`${patterns.gridTableHeader} ${styles.gridCols5}`}>
        <span>Payer</span>
        <span>Phone map</span>
        <span>Provider line</span>
        <span>Strategy</span>
        <span />
      </div>
      {payers.map((p) => (
        <div key={p.id} className={`${patterns.gridTableRow} ${styles.gridCols5}`}>
          <div className={patterns.cellPrimary}>{p.payerName}</div>
          <div>{phoneMapPills(p)}</div>
          <div className={styles.mono}>{p.providerLine ?? '—'}</div>
          <div>{strategyPill(p.effectiveStrategy)}</div>
          <div className={styles.actionCell}>
            <Button size="sm" variant="secondary" onClick={() => onRemove(p)}>
              Remove
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
